export enum BusinessCitationStatuses {
  Synced = 1,
  Submitted = 2,
  Updating = 3,
  ActionRequired = 4,
  Linked = 5,
  Unknown = 6
}